import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-slate" data-id="element-114" data-mp="1o2vhap4uen6k">
      <div className="mx-auto max-w-5xl px-5 py-12 sm:px-8 sm:py-[5.6rem]" data-id="element-115" data-mp="223em7ne0hd4i">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.5
      }} className="flex flex-col items-center gap-6 text-center md:flex-row md:text-left" data-id="element-116" data-mp="222mzl22e6pqd">
          <span className="flex h-20 w-20 shrink-0 items-center justify-center rounded-2xl bg-magenta text-white shadow-lg shadow-magenta/30" data-id="element-117" data-mp="1ee3uswijwv31">
            <ShieldCheckIcon className="h-10 w-10" strokeWidth={1.8} data-id="element-118" data-mp="qmyd0bt1vsq3" />
          </span>
          <div data-id="element-119" data-mp="lo51uq18kdt3">
            <h2 className="font-display text-2xl sm:text-3xl font-extrabold text-white" data-id="element-120" data-mp="lon4q5ielq9z">
              100% Satisfaction Guarantee
            </h2>
            <p className="mt-3 max-w-2xl text-white/75 leading-relaxed" data-id="element-121" data-mp="tycq6fqxn7qw">
              If you are not completely satisfied, we will return within 24
              hours to make it right. Your peace of mind is our priority.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}